<!-- <input type="checkbox" [checked]="checkedVal" (click)="check()" /> -->
<iscustomcheckbox (click)="check()" [formControl]="control"></iscustomcheckbox>
